export default {
  userDataKey: 'userData',
  multiUserDataKey: 'multiUserData',
  permissionHashKey: 'permissionHash',
  localeKey: 'locale',
  sentryKey: 'sentry',

  setUserData(data) {
    window.cloudErpUserData = data;
    const dataJSON = JSON.stringify(data);
    // eslint-disable-next-line no-underscore-dangle
    window.localStorage.setItem(this.userDataKey, dataJSON);
  },

  getUserData() {
    const data = window.localStorage.getItem(this.userDataKey);
    try {
      return data && JSON.parse(data);
    } catch (e) {
      return null;
    }
  },

  getMultiUserData() {
    const data = window.localStorage.getItem(this.multiUserDataKey);
    try {
      return data && JSON.parse(data);
    } catch (e) {
      return null;
    }
  },

  setMultiUserData(data) {
    window.localStorage.setItem(this.multiUserDataKey, JSON.stringify(data));
  },

  getLocale() {
    const data = window.localStorage.getItem(this.localeKey);
    return data && JSON.parse(data);
  },

  setLocale(data) {
    window.localStorage.setItem(this.localeKey, JSON.stringify(data));
  },

  getSentryData() {
    const data = window.localStorage.getItem(this.sentryKey);
    return data && JSON.parse(data);
  },

  setSentryData(data) {
    window.localStorage.setItem(this.sentryKey, JSON.stringify(data));
  },
};
